import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { topFundedAccounts } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export function TopFundedAccounts() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    const timezone = localStorage.getItem('timezone');

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 100 });
    const [sortField, setSortField] = useState("tu.balance");
    const [sortOrder, setSortOrder] = useState("DESC");
    
    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder
            }
            const response = await topFundedAccounts(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading top funded accounts, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();  // ✅ Ensure fetching happens when dependencies change
    }, [pagination, search, sortField, sortOrder]);

    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const formatNumber = (num) => {
        if (!num) return "0";

        const parsed = parseFloat(num);
        return parsed % 1 === 0 
            ? parsed.toFixed(0) 
            : parsed.toFixed(2).replace(/\.?0+$/, "");
    };

    const exportToExcel = async () => {
        const today = new Date().toISOString().slice(0, 10);
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("100 Top Funded Accounts");
    
        const title = `100 Top Funded Accounts - ${today}`;
        const headers = [
            "RANK", "USER NAME", "EMAIL", "DX-USERNAME", "SYNTEL-UID", "BALANCE",
            "AVL. BALANCE", "OPENPL", "TOTALPL", "USED-MARGIN", "OPEN POSITION", "OPEN ORDERS"
        ];
        
        // Title row
        sheet.mergeCells('A1:K1');
        const titleRow = sheet.getCell('A1');
        titleRow.value = title;
        titleRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'B6A878' } };
        titleRow.font = { bold: true, size: 14 };
        titleRow.alignment = { vertical: 'middle', horizontal: 'center' };
    
        // Header row
        const headerRow = sheet.addRow(headers);
        headerRow.eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
        
        // Data rows
        data.forEach((rowData, index) => {
            const row = [
                Number(rowData.rank),
                `${rowData.first_name} ${rowData.last_name}`,
                rowData.email,
                rowData.account_code,
                rowData.syntel_uid,
                Number(rowData.balance),
                Number(rowData.available_balance),
                Number(rowData.openpl),
                Number(rowData.totalpl),
                Number(rowData.margin),
                Number(rowData.open_position),
                Number(rowData.open_orders),
            ];
            const addedRow = sheet.addRow(row);
            const bgColor = (index % 2 === 0) ? 'FFFFFF' : 'E6F2FF';
            addedRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColor }
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            [ 6, 7, 8, 9, 10, 11, 12 ].forEach(colIndex => {
                const cell = addedRow.getCell(colIndex);
                cell.numFmt = '#,##0.00';
            });
        });
    
        // Set column widths (~15% each)
        sheet.columns.forEach(column => {
            column.width = 20;
        });
    
        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `Top_Funded_Accounts_${today}.xlsx`);
    };
    
    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>100 Top Funded Accounts</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">100 Top Funded Accounts</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div className="toolbar">
                                            <div className="row" style={{ marginRight: '0px' }}>
                                                <div className="col-md-9 col-lg-9 col-xl-9 text-left" style={{ marginTop: '30px' }}>
                                                    <button className="btn btn-primary btn-sm" type="button" onClick={exportToExcel}>
                                                        Export
                                                    </button>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="🔍 Search..."
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                padding: "10px 15px",
                                                                borderRadius: "25px",
                                                                border: "1px solid #ccc",
                                                                outline: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                fontSize: "14px",
                                                            }}
                                                            className="form-control mb-3"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { name: "RANK", selector: (row) => {
                                                    if (parseInt(row.rank) === 1) {
                                                        return <label className="label label-success label-xs">{parseInt(row.rank)}</label>
                                                    } else if (parseInt(row.rank) === 2) {
                                                        return <label className="label label-warning label-xs">{parseInt(row.rank)}</label>
                                                    } else if (parseInt(row.rank) === 3) {
                                                        return <label className="label label-danger label-xs">{parseInt(row.rank)}</label>
                                                    } else {
                                                        return <label className="label label-black label-xs">{parseInt(row.rank)}</label>
                                                    }
                                                }, sortable: false, width: '8%' },
                                                { name: "USER NAME", selector: (row) => `${row.first_name} ${row.last_name}`, sortable: false, width: '12%' },
                                                { name: "EMAIL", selector: (row) => row.email, sortable: false, width: '15%' },
                                                { name: "DX-USERNAME", selector: (row) => row.account_code, sortable: false, width: '12%' },
                                                { name: "SYNTEL-UID", selector: (row) => row.syntel_uid, sortable: false, width: '10%' },
                                                { name: "BALANCE", selector: (row) => `${formatNumber(row.balance)} USD`, sortable: false, width: '12%' },
                                                { name: "AVL. BALANCE", selector: (row) => `${formatNumber(row.available_balance)} USD`, sortable: false, width: '12%' },
                                                { name: "OPENPL", selector: (row) => {
                                                    if (row.openpl > 0) {
                                                        return <label className="label label-success label-xs">{formatNumber(row.openpl)}</label>
                                                    } else {
                                                        return <label className="label label-danger label-xs">{formatNumber(row.openpl)}</label>
                                                    }
                                                }, sortable: false, width: '10%' },
                                                { name: "TOTALPL", selector: (row) => {
                                                    if (row.totalpl > 0) {
                                                        return <label className="label label-success label-xs">{formatNumber(row.totalpl)}</label>
                                                    } else {
                                                        return <label className="label label-danger label-xs">{formatNumber(row.totalpl)}</label>
                                                    }
                                                }, sortable: false, width: '10%' },
                                                // { name: "USED-MARGIN", selector: (row) => `${formatNumber(row.margin)} USD`, sortable: false, width: '12%' },
                                                { name: <span title="OPEN POSITION">O.POS</span>, selector: (row) => `${formatNumber(row.open_position)}`, sortable: false, width: '8%' },
                                                { name: <span title="OPEN ORDERS">O.ORDER</span>, selector: (row) => `${formatNumber(row.open_orders)}`, sortable: false, width: '8%' },
                                            ]}
                                            data={data || []}
                                            defaultSortField="tu.balance"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={100} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}